import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showTaskModal    : false,
    showProjectModal : false,
    taskId           : null
  },
  mutations: {
    SET_SHOW_TASK_MODAL (state, aux) {
      state.showTaskModal = aux
    },
    SET_SHOW_PROJECT_MODAL (state, aux) {
      state.showProjectModal = aux
    },
    SET_TASK_ID (state, aux) {
      state.taskId = aux
    }
  },
  actions: {
    openTaskModal ({ commit }) {
      commit('SET_SHOW_PROJECT_MODAL', false)
      commit('SET_SHOW_TASK_MODAL', true)
    },
    closeTaskModal ({ commit }) {
      commit('SET_SHOW_TASK_MODAL', false)
      commit('SET_TASK_ID', null)
    },
    openProjectModal ({ commit }) {
      commit('SET_SHOW_TASK_MODAL', false)
      commit('SET_TASK_ID', null)
      commit('SET_SHOW_PROJECT_MODAL', true)
    },
    closeProjectModal ({ commit }) {
      commit('SET_SHOW_PROJECT_MODAL', false)
    },
    editTask ({ commit }, id) {
      commit('SET_SHOW_TASK_MODAL', false)
      commit('SET_TASK_ID', id)
      commit('SET_SHOW_TASK_MODAL', true)
    }
  },
  getters: {}
})



// WEBPACK FOOTER //
// ./src/store.js